
import {
  Box,
  Button,
  Grid,
  Pagination,
  Paper,
  Table,
  TableContainer,
  TableHead,
  Typography,
} from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { blueGrey, grey, yellow } from "@mui/material/colors";
import { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CompanyPartHeader } from "../../components/PartHeader";
import SelectBox from "../../components/SelectBox";
import ConfirmDialog from "../../components/dialog/ConfirmDialog";
import useInputObject from "../../hooks/useInputObject";
import { deleteBuyer, downloadBuyerPrintInfo, getBuyerInfo } from "../../http/api/BuyerAPI";
import { delay, formatPostalCode } from "../../utils/utils";
import { CompanyTitledPage } from "../TitledPage";
import SearchForm from "./SearchForm";
import LoadingModal from "../../components/LoadingModal";
import PrintPreview from "../invoice/PrintManagePage/PrintPreview";

const infoTableCellSx = {
  fontSize: 17,
};

const BuyerPage = () => {
  const columns = [
    "買人No",
    "買人名",
    // "買人フリガナ",
    // "取引先",
    // "店舗",
    "入金区分",
    "締日",
    "郵便番号",
    "住所",
    "TEL",
    "FAX",
    // "メール",
    // "事業者登録番号",
    // "請求先コード",
    // "統計先コード",
    "",
  ];
  const [listBuyer, setListBuyer] = useState([]);
  const [APIListBuyer, setAPIListBuyer] = useState([]);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [isLoading, setLoading] = useState(false);

  const navigate = useNavigate();
  const searchData = useInputObject({ buyer: "" });
  const deleteDialog = useInputObject({ open: false, deleteItem: {} });
  const printPreview = useInputObject({
    open: false,
    url: "",
  });

  useEffect(() => {
    getListBuyer();
  }, []);

  useEffect(() => {
    setListBuyer(APIListBuyer);
  }, [APIListBuyer]);

  async function getListBuyer() {
    try {
      setLoading(true);
      const response = await getBuyerInfo({});
      setAPIListBuyer(response.listBuyerInfo);
      setPage(1);
    } catch {
      setAPIListBuyer([]);
    } finally {
      setLoading(false);
    }
  }

  async function handleSearch(searchData) {
    try {
      const newListBuyer = APIListBuyer.filter(
        (buyer) =>
          buyer.buyerNo == searchData.buyer ||
          buyer.buyerName.includes(searchData.buyer)
      );
      setListBuyer(newListBuyer);
      setPage(1);
    } catch {
      setListBuyer([]);
    }
  }

  async function onClickDeleteBuyer(data) {
    deleteDialog.updates({ open: true, deleteItem: data });
  }

  async function deleteSelectedBuyer() {
    const deleteBuyerNo = deleteDialog.Value.deleteItem.buyerNo;
    const userDelete = 1; //TODO : JWT
    const deleteParams = {
      buyerNo: deleteBuyerNo,
      updatedId: userDelete,
    };
    try {
      setLoading(true);
      await deleteBuyer(deleteParams);
      alert("買人を削除しました。");
      const newListBuyer = APIListBuyer.filter(
        (buyer) => !(buyer.buyerNo === deleteBuyerNo)
      );
      setAPIListBuyer(newListBuyer);
    } catch {
      alert("買人を削除できませんでした。");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    setPage(1);
  }, [itemsPerPage]);

  async function printBuyer() {
    try {
      //　ローディング　表示
      setLoading(true);
      // request to server 
      // request body 宣言
      const requestBody = {};
      // download 結果　受け取る
      const result = await downloadBuyerPrintInfo(requestBody);
      //印刷情報設定
      if (result) {
        const blob = new Blob([result], {
          type: "application/pdf",
          encoding: "UTF-8",
        });
        const fileUrl = URL.createObjectURL(blob);
        printPreview.updates({ open: true, url: fileUrl });
      }
    } catch (error) {

    }
    finally {
      //　ローディング　非表示
      setLoading(false);
    }

  };

  return (
    <Fragment>
      <CompanyTitledPage title="買人管理">
        <SearchForm searchData={searchData} search={handleSearch} />

        <CompanyPartHeader>
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            my={1}
          >
            <Grid item xs="auto">
              <Typography fontWeight="bold" fontSize={20}>
                検索一覧
                {listBuyer.length > 0 ? `（件数：${listBuyer.length}）` : ""}
              </Typography>
            </Grid>
            <Grid item xs="auto">

              <Button
                variant="outlined"
                onClick={printBuyer}
              >

                買人一覧印刷
              </Button>
              <Button
                variant="outlined"
                onClick={() => navigate(`/company/buyer_insert/`)}
              >
                買人を登録
              </Button>
            </Grid>
          </Grid>
        </CompanyPartHeader>

        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                {columns.map((columnName, i) => {
                  return (
                    <TableCell
                      key={`${columnName}_${i}`}
                      sx={{ ...infoTableCellSx, backgroundColor: grey[100] }}
                    >
                      {columnName}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {listBuyer
                .slice(
                  (page - 1) * itemsPerPage,
                  (page - 1) * itemsPerPage + itemsPerPage
                )
                .map((data, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      "&:hover": {
                        backgroundColor: blueGrey[50],
                      },
                    }}
                  >
                    {/* 買人No */}
                    <TableCell sx={{ ...infoTableCellSx, width: 100 }}>
                      {data.buyerNo}
                    </TableCell>
                    {/* 買人名 */}
                    <TableCell sx={{ ...infoTableCellSx, width: 370 }}>
                      {data.buyerName}
                    </TableCell>
                    {/* 入金区分 */}
                    <TableCell sx={{ ...infoTableCellSx, width: 100 }}>
                      {data.receiptDivisionName}
                    </TableCell>
                    {/* 締日グループ */}
                    <TableCell sx={{ ...infoTableCellSx, width: 120 }}>
                      {data.closingDateGroupContent?.replace("99", "月末")}
                    </TableCell>
                    {/* 郵便番号 */}
                    <TableCell sx={{ ...infoTableCellSx, width: 110 }}>
                      {formatPostalCode(data.postCode)}
                    </TableCell>
                    {/* 住所 */}
                    <TableCell sx={{ ...infoTableCellSx, width: 450 }}>
                      {data.address}
                    </TableCell>
                    {/* TEL */}
                    <TableCell sx={{ ...infoTableCellSx, width: 150 }}>
                      {data.tel}
                    </TableCell>
                    {/* FAX */}
                    <TableCell sx={{ ...infoTableCellSx, width: 150 }}>
                      {data.fax}
                    </TableCell>

                    {/* 編集・削除 */}
                    <TableCell sx={{ ...infoTableCellSx, width: 70 }}>
                      <Box display="flex" justifyContent="flex-end">
                        <Button
                          variant="outlined"
                          sx={{ marginRight: 3 }}
                          onClick={() => {
                            navigate(`/company/buyer_edit/`, {
                              state: {
                                buyerInfo: data,
                              },
                            });
                          }}
                        >
                          編集
                        </Button>
                        <Button
                          variant="outlined"
                          color="error"
                          onClick={() => {
                            onClickDeleteBuyer(data);
                          }}
                        >
                          削除
                        </Button>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <Grid container display="flex" justifyContent="space-between" mt={5}>
          <Grid item xs={2}>
            <SelectBox
              data={[10, 25, 50].map((x) => {
                return {
                  key: x,
                  value: x,
                };
              })}
              onChange={(e) => {
                setItemsPerPage(e.target.value);
              }}
              value={itemsPerPage}
              sx={{ width: 100 }}
              label={"表示件数　"}
              nullable={false}
            />
          </Grid>
          <Grid item xs={8} display="flex" justifyContent="center">
            <Pagination
              count={Math.floor(listBuyer.length / itemsPerPage) + 1}
              page={page}
              onChange={(e, newPage) => {
                setPage(newPage);
              }}
              variant="outlined"
              shape="rounded"
            />
          </Grid>
          <Grid item xs={2}></Grid>
        </Grid>

        <ConfirmDialog
          open={deleteDialog.Value.open}
          onClose={() => deleteDialog.update("open", false)}
          title="買人を削除確認"
          action={deleteSelectedBuyer}
          buttonAcceptLabel="削除"
        >
          <Box marginTop={2} marginBottom={1}>
            <Typography>以下の買人を削除します。</Typography>
            <Box backgroundColor={yellow[100]} marginY={1} padding={1}>
              <Typography>
                買人No：{deleteDialog.Value.deleteItem.buyerNo}
              </Typography>
              <Typography>
                買人名：{deleteDialog.Value.deleteItem.buyerName}
              </Typography>
            </Box>
          </Box>
        </ConfirmDialog>

        <LoadingModal label="取得中" open={isLoading} />
        <PrintPreview printPreview={printPreview} />
      </CompanyTitledPage>
    </Fragment>
  );
};
export default BuyerPage;
